import { render, staticRenderFns } from "./CharactersWeaponSupremacies.vue?vue&type=template&id=50efbbcb&lang=pug&"
import script from "./CharactersWeaponSupremacies.vue?vue&type=script&lang=ts&"
export * from "./CharactersWeaponSupremacies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports